import React, { useState } from 'react';
import styled from 'styled-components';
import { TABLET_WIDTH } from '~~elements/Const';
import { PlayerResource } from '~~apis/resource';
import PlayerHeader from './PlayerHeader';
import PermissionList from './PermissionList';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  letter-spacing: 1px;
  padding-top: 2rem;

  @media (max-width: ${TABLET_WIDTH}) {
    align-items: center;
  }
`;

const permissionTooltipMapping = {
  ADMIN: '可進行所有操作，至少需有一位管理者',
  EDITOR: '不得修改管理者權限',
  VIEWER: '僅提供瀏覽管理資訊，不得做任何修改',
};

const PlayerPermission = ({ userInfo, players, reload }) => {
  const [playerIndex, setPlayerIndex] = useState(0);
  const updatePermission = ({ userUniqid, targetUniqid, authority }) => {
    return PlayerResource.updatePermission({ userUniqid, playerUniqid: targetUniqid, authority });
  };

  return (
    <StyledDiv>
      {players.length > 0 && (
        <PlayerHeader players={players} playerIndex={playerIndex} setPlayerIndex={setPlayerIndex} />
      )}
      <PermissionList
        userInfo={userInfo}
        target={players[playerIndex]}
        updatePermission={updatePermission}
        reload={reload}
        permissionTooltipMapping={permissionTooltipMapping}
      />
    </StyledDiv>
  );
};

export default PlayerPermission;
